module.exports = __webpack_public_path__ + "img/BarometroBlack.a0388954.svg";